import type { IAppConfig } from '@/typescript/interfaces/IAppConfig';

// Stands in for the configuration the host merchant site normally provides, so the
// configurator can be opened on its own during development.
//
// `is_mobile` comes from the host, never from the viewport: run standalone it was always
// false, which made the touch interface unreachable outside an integration -- and made a
// narrow window look like the mobile interface when it is only the desktop one squeezed.
// `?mobile=1` reaches it, the same way the `/admin` segment reaches administrator mode.
export function mockConfig(): IAppConfig {
    const segments = window.location.pathname.split('/').filter(Boolean);
    const isAdmin = segments.includes('admin');
    const isMobile = new URLSearchParams(window.location.search).get('mobile') === '1';
    return {
        lang: 'fr_Fr',
        is_mobile: isMobile,
        token: import.meta.env.VITE_API_TOKEN,
        product_type: '',
        is_admin: isAdmin,
    };
}
